import { render, staticRenderFns } from "./battleNetUserNeedDel.vue?vue&type=template&id=905798d2"
import script from "./battleNetUserNeedDel.vue?vue&type=script&lang=js"
export * from "./battleNetUserNeedDel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports